var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import { listItemMsg } from '../../FormattedListValue';
var messages = defineMessages({
    TaskTemplates: {
        id: 'TaskTemplates',
        defaultMessage: 'Task templates',
    },
    TasksWithoutTemplate: {
        id: 'TasksWithoutTemplate',
        defaultMessage: 'Tasks without template',
    },
});
export var TaskTemplateMultiSelect = function (_a) {
    var selection = _a.selection, onChange = _a.onChange, placeholder = _a.placeholder;
    var formatMessage = useIntl().formatMessage;
    var data = useGetTaskTemplates().data;
    var items = useMemo(function () { return __spreadArray([
        { id: guid.empty, label: formatMessage(messages.TasksWithoutTemplate) }
    ], (data !== null && data !== void 0 ? data : [])
        .map(function (item) { return ({
        id: item.id,
        label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
    }); })
        .sort(dynamicSort('label')), true); }, [data, formatMessage]);
    var _b = splitItems(items, selection), selectedItems = _b[0], selectableItems = _b[1];
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: function (item) { return onChange(removeItem(selection, item)); }, onItemSelected: function (item) { return onChange(addItem(selection, item)); }, items: selectableItems, placeholder: placeholder || formatMessage(messages.TaskTemplates) }));
};
